<template>
	<shutter-panel ref="shutterPanel" />
</template>


<script type="text/javascript">
    import Shutter from "@/mixins/Shutter.js"
    import ShutterActs from '@/mixins/shutters-manager/Acts.js'

	export default {
		name: "acteListe",
		mixins: [
            Shutter, 
            ShutterActs,
        ],
		props: {
            horse_id: { type: Number, default: 0 },
			acte_statut: { type: Number, default: 0 }
		},
		mounted() {
            this.init_component()
		},
		methods: {
			init_component() {
				this.setupHorseActes(this.horseId, this.acte_statut)
			}
        },
        computed: {
			horseId() {
				return parseInt(this.$route.params.horse_id)
			}
		},
		watch: {
			acte_statut(val) {
				this.shutterPanel().update('act-horse', 'acte_statut', val)
			}
		}
	}
</script>
